import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { useNavigate, useParams } from 'react-router-dom';
import { changeAgentSearchtUser } from '../../reducers/telegram/telegram-slice';

const Search = () => {
  const [username, setUsername] = useState('');
  const [err, setErr] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const debouncedSearch = setTimeout(() => {
      dispatch(changeAgentSearchtUser(username));
    }, 1000);
    return () => {
      clearTimeout(debouncedSearch);
    };
  }, [username]);

  return (
    <div className="search my-2">
      <div className="searchForm flex gap-2 align-items-center justify-content-center px-2">
        <div className="flex-grow-1">
          <span className="p-input-icon-right w-full">
            {!username || username?.length === 0 ? (
              <i className="pi pi-search" />
            ) : (
              <i
                className="pi pi-times cursor-pointer"
                onClick={() => {
                  setUsername('');
                  //   navigate(`/chat`);
                }}
              />
            )}
            <InputText
              type="text"
              placeholder="Search customer"
              onChange={(e) => {
                setInitialLoad(false);
                setUsername(e.target.value);
              }}
              value={username}
              className="chat-search capitalize"
            />
          </span>
        </div>
      </div>

      {err && <span>Customer not found!</span>}
    </div>
  );
};

export default Search;
